// style
import './style/header.css'
// link
import { Link, NavLink } from "react-router-dom";
// routes
import { routes } from "../../../../features/routes/route.tsx";
// react
import React, { useEffect, useState } from 'react';
// cookie
import Cookies from "js-cookie";
const Header = () => {
    let [userStatus, setUserStatus] = useState<string>('client')
    useEffect(() => {
        let token = Cookies.get('agent_token');
        let photoToken = Cookies.get('photographer_token');
        if (token) {
            setUserStatus('agent');
        }
        else if (photoToken) {
            setUserStatus('photograph');
        }
        else {
            setUserStatus('client')
        }
    }, [])
    return (
        <>
            <header className="header py-md-4 pb-md-4 pt-4 pb-2">
                <section className="navbar shadow navbar-expand-md rounded rounded-4 border border-white py-3 bg-white">
                    <div className="container-fluid">
                        <Link className="text-white mb-0 fw-bold h4 text-decoration-none"
                            to={routes.client[0].address}>
                            مادوند ملک
                        </Link>
                        <button data-bs-toggle="modal" data-bs-target="#agent" className='btn d-md-none d-md-inline-block btn-primary font-medium-lg fw-bold border-0'>
                            ثبت نام مشاور
                        </button>
                        <div className="collapse navbar-collapse justify-content-end">
                            <ul className="nav navbar-nav">
                                {userStatus === 'client' ? (
                                    <>
                                        {routes.client.map((link: object | any) => (
                                            <li key={link?.label} className="nav-item text-white">
                                                <NavLink to={link.address} data-bs-toggle="modal" className="nav-link font-font-medium-lg text-white ms-2">
                                                    {link.label}
                                                </NavLink>
                                            </li>
                                        ))}
                                    </>
                                ) : (
                                    <>
                                        {userStatus === "agent" ? (
                                            <>
                                                <li className="nav-item text-white">
                                                    <NavLink to={'/agent/panel'} className="btn btn-primary nav-link font-font-medium-lg ms-2">
                                                        پنل مشاور
                                                    </NavLink>
                                                </li>
                                            </>
                                        ) : (
                                            <>
                                                <li className="nav-item text-white">
                                                    <NavLink to={'/photographer/panel'} className="btn btn-primary nav-link font-font-medium-lg ms-2">
                                                        پنل عکاس
                                                    </NavLink>
                                                </li>
                                            </>
                                        )}
                                    </>
                                )}
                            </ul>
                        </div>
                    </div>
                </section>
            </header>
        </>
    )
}

export default Header;